/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_New_Event_Group_ModalInputs */

const en_close_new_event_group_modal = /** @type {(inputs: Close_New_Event_Group_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close new event group modal`)
};

const fr_close_new_event_group_modal = /** @type {(inputs: Close_New_Event_Group_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la fenêtre de nouveau groupe d’événements`)
};

const de_close_new_event_group_modal = /** @type {(inputs: Close_New_Event_Group_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen des Modals für neue Ereignisgruppen`)
};

const it_close_new_event_group_modal = /** @type {(inputs: Close_New_Event_Group_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi la nuova finestra modale del gruppo di eventi`)
};

const ru_close_new_event_group_modal = /** @type {(inputs: Close_New_Event_Group_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть модальное окно новой группы событий`)
};

const es_close_new_event_group_modal = /** @type {(inputs: Close_New_Event_Group_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar el nuevo grupo de eventos modal`)
};

const zh_cn2_close_new_event_group_modal = /** @type {(inputs: Close_New_Event_Group_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭新建事件组模态框`)
};

const ja_close_new_event_group_modal = /** @type {(inputs: Close_New_Event_Group_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいイベントグループモーダルを閉じる`)
};

const hi_close_new_event_group_modal = /** @type {(inputs: Close_New_Event_Group_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नए इवेंट समूह मॉडल को बंद करें`)
};

const pt_pt2_close_new_event_group_modal = /** @type {(inputs: Close_New_Event_Group_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar modal de novo grupo de eventos`)
};

/**
* | output |
* | --- |
* | "Close new event group modal" |
*
* @param {Close_New_Event_Group_ModalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_new_event_group_modal = /** @type {((inputs?: Close_New_Event_Group_ModalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_New_Event_Group_ModalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_close_new_event_group_modal(inputs)
	if (locale === "de") return de_close_new_event_group_modal(inputs)
	if (locale === "it") return it_close_new_event_group_modal(inputs)
	if (locale === "ru") return ru_close_new_event_group_modal(inputs)
	if (locale === "es") return es_close_new_event_group_modal(inputs)
	if (locale === "zh-CN") return zh_cn2_close_new_event_group_modal(inputs)
	if (locale === "ja") return ja_close_new_event_group_modal(inputs)
	if (locale === "hi") return hi_close_new_event_group_modal(inputs)
	if (locale === "pt-PT") return pt_pt2_close_new_event_group_modal(inputs)
	return en_close_new_event_group_modal(inputs)
});